import { render } from "./VibrationSheet.vue?vue&type=template&id=38930c72&ts=true"
import script from "./VibrationSheet.vue?vue&type=script&lang=ts"
export * from "./VibrationSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__